import Painting from "./Painting";
import portfolio1 from "../../assets/img/art/portfolio-1.jpg";
import portfolio2 from "../../assets/img/art/portfolio-2.jpg";
import portfolio3 from "../../assets/img/art/portfolio-3.jpg";
import portfolio4 from "../../assets/img/art/portfolio-4.jpg";
export default function PaintingGallery() {
    
    const galleryStyle = {
        marginTop: '20px',
    };
    
    return (
        <div style={galleryStyle} className="container">
            <div className="row">
                <div className="col-md-6">
                    <Painting
                        title="Galadrimel"
                        medium="Digital Art"
                        relativeImagePath={portfolio1}
                    />
                </div>
                <div className="col-md-6">
                    <Painting
                        title="My Grandmother"
                        medium="Oil on Canvas"
                        relativeImagePath={portfolio2}
                    />
                </div>
                <div className="col-md-6">
                    <Painting
                        title="Self Portrait"
                        medium="Oil Pastels on Craft"
                        relativeImagePath={portfolio3}
                    />
                </div>
                <div className="col-md-6">
                    <Painting
                        title="Arthur Morgan"
                        medium="Digital Art"
                        relativeImagePath={portfolio4}
                    />
                </div>
            </div>
        </div>
    );
}